import { Box, Container, Heading } from '@hover/blueprint';
import { Link } from 'gatsby';
import React from 'react';
import ArrowButton from '../../ui/ArrowButton';

const CareersContactUs: React.FC = () => (
  <Box w="100%" bg="brandNavy.500" py={{ base: 800, desktop: 1000 }}>
    <Container maxW="5xl" centerContent>
      <Heading
        textAlign="center"
        style={{ color: 'white', marginBottom: 40 }}
        size={{ base: 500, tablet: 600, desktop: 700 }}
      >
        Still have questions? We’re here to help.
      </Heading>
      <ArrowButton
        colorScheme="brandNavy"
        variant="inverted"
        w={{ base: '100%', tablet: 'auto' }}
        as={Link}
        to={`${process.env.GATSBY_V2_PREFIX}/contact`}
      >
        Contact us
      </ArrowButton>
    </Container>
  </Box>
);

export default CareersContactUs;
